import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import cls from 'classnames';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';

// @material-ui/icons
import Email from '@material-ui/icons/Email';

// ui-kit
import {
  Icon as IconUikit, ICONS, palette, ProviderValidate,
} from '@bagonboard/ui-kit';

// core components
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import CustomInput from '../../../components/CustomInput/CustomInput';
import Button from '../../../components/CustomButtons/Button';
import Card from '../../../components/Card/Card';
import CardBody from '../../../components/Card/CardBody';
import CardHeader from '../../../components/Card/CardHeader';
import CardFooter from '../../../components/Card/CardFooter';
import Snackbar from '../../../components/Snackbar/Snackbar';

import * as actions from '../../../reducers/User/actions';

import { constraints } from './constants';
import loginPageStyle from './loginPageStyle';

// TODO: Need refactor
class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cardAnimaton : 'cardHidden',
      email        : '',
      emailError   : '',
      password     : '',
      passwordError: '',
    };
  }

  componentDidMount() {
    this.timeOutFunction = setTimeout(() => {
      this.setState({ cardAnimaton: '' });
    }, 700);
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  onChangeEmail = (event) => {
    this.setState({ email: event.target.value, emailError: false });
  };

  onChangePassword = (event) => {
    this.setState({ password: event.target.value, passwordError: false });
  };

  keyPressed = (event) => {
    const code = event.keyCode || event.which;
    if (code === 13) { // 13 is the enter keycode
      this.onSubmit();
    }
  }

  onSubmit = () => {
    const { login } = this.props;
    const { email, password } = this.state;

    const errors = ProviderValidate.validate({ email, password }, constraints);
    if (errors) {
      this.setState({
        emailError   : errors.email && errors.email[0],
        passwordError: errors.password && errors.password[0],
      });
    } else {
      login({ email, password });
    }
  };

  render() {
    const { classes, user } = this.props;
    const { cardAnimaton, emailError, passwordError } = this.state;

    if (user.data && user.data.id) return <Redirect to="/" />;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form>
              <Card login className={cls(classes[cardAnimaton])}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="danger"
                >
                  <IconUikit color={palette.white} icon={ICONS.BOB} size={40} />
                  <h4 className={classes.cardTitle}>Login</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    data-testid="input-email"
                    error={!!emailError}
                    helpText={emailError}
                    id="email"
                    labelText="Email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type        : 'email',
                      endAdornment: (
                        <InputAdornment position="end">
                          <Email className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      onChange    : this.onChangeEmail,
                      autoComplete: 'username',
                      onKeyPress  : this.keyPressed,
                    }}
                  />
                  <CustomInput
                    data-testid="input-password"
                    error={!!passwordError}
                    helpText={passwordError}
                    id="password"
                    labelText="Password"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>visibility_off</Icon>
                        </InputAdornment>
                      ),
                      onChange    : this.onChangePassword,
                      type        : 'password',
                      autoComplete: 'current-password',
                      onKeyPress  : this.keyPressed,
                    }}
                  />
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  <Button data-testid="button-login" color="info" onClick={this.onSubmit} size="sm">
                    LOG IN
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
        <Snackbar color="danger" message={user.error || ''} open={!!user.error} />
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  login  : PropTypes.func.isRequired,
  user   : PropTypes.shape({
    id: PropTypes.string,
  }),
};

LoginPage.defaultProps = {
  user: {},
};

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = dispatch => ({
  login: data => dispatch(actions.login(data)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(loginPageStyle),
)(LoginPage);
